/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageUsersSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageUsersSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageUsersSecurity = {
  option1?: GetToolUsageUsersSecurityOption1 | undefined;
  option2?: GetToolUsageUsersSecurityOption2 | undefined;
};

export type GetToolUsageUsersRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageUsersSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageUsersSecurityOption1$outboundSchema: z.ZodMiniType<
  GetToolUsageUsersSecurityOption1$Outbound,
  GetToolUsageUsersSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getToolUsageUsersSecurityOption1ToJSON(
  getToolUsageUsersSecurityOption1: GetToolUsageUsersSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageUsersSecurityOption1$outboundSchema.parse(
      getToolUsageUsersSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageUsersSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageUsersSecurityOption2$outboundSchema: z.ZodMiniType<
  GetToolUsageUsersSecurityOption2$Outbound,
  GetToolUsageUsersSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolUsageUsersSecurityOption2ToJSON(
  getToolUsageUsersSecurityOption2: GetToolUsageUsersSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageUsersSecurityOption2$outboundSchema.parse(
      getToolUsageUsersSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageUsersSecurity$Outbound = {
  Option1?: GetToolUsageUsersSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageUsersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageUsersSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageUsersSecurity$Outbound,
  GetToolUsageUsersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageUsersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageUsersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageUsersSecurityToJSON(
  getToolUsageUsersSecurity: GetToolUsageUsersSecurity,
): string {
  return JSON.stringify(
    GetToolUsageUsersSecurity$outboundSchema.parse(getToolUsageUsersSecurity),
  );
}

/** @internal */
export type GetToolUsageUsersRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageUsersRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageUsersRequest$Outbound,
  GetToolUsageUsersRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageUsersRequestToJSON(
  getToolUsageUsersRequest: GetToolUsageUsersRequest,
): string {
  return JSON.stringify(
    GetToolUsageUsersRequest$outboundSchema.parse(getToolUsageUsersRequest),
  );
}
